/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { RichText } from '@hyphengroup/cms-components/components/RichText';
import Tooltip from '@hyphengroup/cms-components/components/Tooltip';
import { EditorsPickActions } from './EditorsPickActions';
import { EditorsPickLogo } from './EditorsPickLogo';
import { EditorsPickBodyProps } from './types';

export const EditorsPickBody = ({
  buttonTarget,
  content,
  model,
  onApplyClick,
  onViewDetailsClick,
  viewDetailsLabel,
}: EditorsPickBodyProps) => {
  return (
    <>
      <RichText
        className="whitespace-break-spaces text-text/primary"
        baseTextStyle="Body2Relaxed"
      >
        {content}
      </RichText>

      <div className="w-full">
        <article className="flex h-full flex-col gap-spacing/gap/soft-12px">
          {model.badge && (
            <div className="rounded-radius/button px-spacing/padding/soft-8px py-spacing/padding/soft-4px bg-highlights/green-light">
              <div className="mhg-alpha-typography-bullet-2 text-highlights/green-dark">
                {model.badge}
              </div>
            </div>
          )}

          <div className="flex items-center gap-[--spacing-padding-soft-12px]">
            <EditorsPickLogo
              key={`${model.primaryMediaSrc}|${model.fallbackMediaSrc}|${model.fallbackText}`}
              alt={model.product?.product_name || 'Product image'}
              fallbackText={model.fallbackText}
              fallbackSrc={model.fallbackMediaSrc}
              primarySrc={model.primaryMediaSrc}
            />

            <div className="min-w-0 flex-1">
              <h3 className="mhg-alpha-typography-caption line-clamp-1 text-text/secondary-lighter">
                {model.product?.product_name}
              </h3>
              {model.attributeValue && (
                <div className="mt-spacing/padding/soft-4px flex items-center gap-spacing/gap/x-xs">
                  <p className="mhg-alpha-typography-bullet-2 text-text/primary">
                    {model.attributeValue}
                  </p>
                  {model.attributeTooltip && (
                    <Tooltip
                      placement="top"
                      infoClass="!size-[--shapes-icon-size-sm] text-text/disabled"
                      content={model.attributeTooltip}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <EditorsPickActions
            applyLabel={model.applyLabel}
            applyUrl={model.applyUrl}
            buttonTarget={buttonTarget}
            onApplyClick={onApplyClick}
            onViewDetailsClick={onViewDetailsClick}
            showApply={model.showApply}
            showDetails={model.showDetails}
            viewDetailsLabel={viewDetailsLabel}
          />
        </article>
      </div>
    </>
  );
};
